import { useZuiContext } from '@ctw/shared/context/zui-provider';
import { tw } from '@ctw/shared/utils/tailwind';
import { siblingPathname } from '@ctw/shared/utils/url';
import { useCallback } from 'react';
import { type OverviewResources, PatientOverview } from './patient-overview';

export const PatientOverviewZap = () => {
  const { navigate, pathname } = useZuiContext();

  const handleSeeAllResources = useCallback(
    (resource: OverviewResources) => {
      navigate(siblingPathname(pathname, resource));
    },
    [navigate, pathname],
  );

  return <PatientOverview className={tw`pt-5`} onSeeAllResources={handleSeeAllResources} />;
};
